// extracted by mini-css-extract-plugin
module.exports = {"container":"_kq","image":"_kr","content":"_ks","title":"_kt","text":"_ku","readMore":"_kv","button":"_kw"};